import React from 'react';
import PropTypes from 'prop-types';
import { isString } from 'lodash';

import { ContentZonesService, LocaleService } from '@sm360/widget-commons-core-services';
import { ModalService } from '@sm360/widget-commons-general';

import InformationZone from 'login/components/Library/InformationZone/InformationZone.jsx';

import { SAVE_CONFIRMATION } from 'login/constants/modalNames.js';

import 'login/components/SaveConfirmation/SaveConfirmationModal.scss';

const czGroupName = 'widget.login.forms.signup';
const OfficialTradeInModal = ModalService.get('trade-in-official-modal');

class SaveConfirmationContent extends React.Component {
    constructor() {
        super();
        this.modal = ModalService.get(SAVE_CONFIRMATION);

        this.headerTitleCz =
            ContentZonesService.getContentZone(czGroupName, 'maintext') &&
            ContentZonesService.getContentZone(czGroupName, 'maintext').getText();
        this.headerTextCz =
            ContentZonesService.getContentZone(czGroupName, 'subtext') &&
            ContentZonesService.getContentZone(czGroupName, 'subtext').getText();
        this.modalImageUrl =
            ContentZonesService.getContentZone(czGroupName, 'image') &&
            ContentZonesService.getContentZone(czGroupName, 'image').getValue();

        this.closeModal = this.closeModal.bind(this);
        this.loginToOfficialize = this.loginToOfficialize.bind(this);
    }

    closeModal() {
        this.modal.close();
    }

    loginToOfficialize() {
        OfficialTradeInModal.open();
        this.closeModal();
    }

    render() {
        const classUtil = isString(this.props.classParam) ? this.props.classParam : '';
        return (
            <div className={`modal-confirmation-content ${classUtil}`}>
                <div className="SaveConfirmation">
                    <div className="SaveConfirmation__header">
                        <icon className="icon-check-mark" />
                        <span>{LocaleService.t('TRADE_IN.CONFIRMATION.TITLE')}</span>
                    </div>
                    <div className="SaveConfirmation__text">
                        <p>{LocaleService.t('TRADE_IN.CONFIRMATION.CONTENT_TEXT')}</p>
                        <p>{LocaleService.t('TRADE_IN.CONFIRMATION.CONTENT_SUBTEXT')}</p>
                    </div>
                    <button className="sr-button-1" onClick={this.loginToOfficialize}>
                        {LocaleService.t('TRADE_IN.CONFIRMATION.OFFICIAL_BUTTON')}
                    </button>
                    <button
                        className="sr-link continue-shopping"
                        onClick={this.closeModal}
                        dataTest="trade-in.trade-in-cta.continue-shopping"
                    >
                        {LocaleService.t('TRADE_IN.CONFIRMATION.BACK_TO_SHOP')}
                    </button>
                </div>
                <InformationZone groupName={this.props.context} czOldImage={this.modalImageUrl} />
            </div>
        );
    }
}
SaveConfirmationContent.defaultProps = {
    classParam: null,
    context: 'widget.login.signup.information',
};

SaveConfirmationContent.propTypes = {
    context: PropTypes.string,
    classParam: PropTypes.string,
};

SaveConfirmationContent.displayName = 'SaveConfirmationContent';

export default SaveConfirmationContent;
